import "../css/custom.css";
import "../css/bootstrap.min.css";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";


const Header = () => {

    const [isScrolled, setIsScrolled] = useState(false);

    const [isOpenNav, setIsOpenNav] = useState(false);

    const toggleNav = () => {
        setIsOpenNav(!isOpenNav);
    };


    useEffect(() => {



        const handleScroll = () => {
            const scrollTop = window.scrollY;
            if (scrollTop > 0) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        }
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };

    }, []);

    return (
        <>
            <nav className={`navbar navbar-expand-lg navbar-custom navbar-light ${isScrolled ? 'fixed-top' : ''}`} >
                <div className="container">
                    <Link className="navbar-brand mr-auto" to="/">
                        <img src="/images/logo.svg" alt="" />
                    </Link>

                    <button className={`navbar-toggler ${isOpenNav ? '' : 'collapsed'}`} onClick={toggleNav} type="button" data-toggle="collapse" data-target="#navbarToggler" aria-controls="navbarToggler" aria-expanded="false" aria-label="Toggle navigation">
                        <svg className={`ham hamRotate ham1 ${isOpenNav ? 'active' : ''}`} viewBox="0 0 100 100" width="60"><path className="line top" d="m 30,33 h 40 c 0,0 9.044436,-0.654587 9.044436,-8.508902 0,-7.854315 -8.024349,-11.958003 -14.89975,-10.85914 -6.875401,1.098863 -13.637059,4.171617 -13.637059,16.368042 v 40"></path><path class="line middle" d="m 30,50 h 40"></path><path class="line bottom" d="m 30,67 h 40 c 12.796276,0 15.357889,-11.717785 15.357889,-26.851538 0,-15.133752 -4.786586,-27.274118 -16.667516,-27.274118 -11.88093,0 -18.499247,6.994427 -18.435284,17.125656 l 0.252538,40"></path></svg>
                    </button>

                    <div className={`collapse navbar-collapse justify-content-start justify-content-sm-end ${isOpenNav ? 'show' : ''}`} id="navbarToggler">
                        <ul className="navbar-nav ml-auto">
                            <li><Link className="nav-link active" to="/">Home</Link></li>
                            <li><Link className="nav-link" to="/aboutUs">About Us</Link></li>
                            <li><Link className="nav-link" to="/contact">Contact</Link></li>
                        </ul>
                    </div>
                </div>
            </nav>
        </>
    );
};
export default Header;